/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum SubscriptionTier {
  FREE = "free",
  BASIC = "basic",
  PREMIUM_1 = "premium_1",
  PREMIUM_2 = "premium_2",
  ENTERPRISE = "enterprise",
}
